import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Pages
import { HomePage } from '@/pages/HomePage';
import { DashboardPage } from '@/pages/DashboardPage';
import { FeaturesPage } from '@/pages/FeaturesPage';
import { ModelPage } from '@/pages/ModelPage';
import { PrivacyPage } from '@/pages/PrivacyPage';
import { TermsPage } from '@/pages/TermsPage';
import { DisclaimerPage } from '@/pages/DisclaimerPage';
import { CustomModelPage } from '@/pages/CustomModelPage';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          {/* Legal pages */}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          {/* Custom model - password protected, coming soon */}
          <Route path="/custom-model" element={<CustomModelPage />} />
          {/* Dynamic model routes - supports all 10 business types */}
          <Route path="/model/:modelType" element={<ModelPage />} />
          {/* Legacy URL support for backward compatibility */}
          <Route path="/saas" element={<ModelPage />} />
          <Route path="/ecommerce" element={<ModelPage />} />
          <Route path="/restaurant" element={<ModelPage />} />
          <Route path="/marketplace" element={<ModelPage />} />
          <Route path="/manufacturing" element={<ModelPage />} />
          <Route path="/consulting" element={<ModelPage />} />
          <Route path="/retail" element={<ModelPage />} />
          <Route path="/cloudkitchen" element={<ModelPage />} />
          <Route path="/fintech" element={<ModelPage />} />
          <Route path="/healthcare" element={<ModelPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
